import { ReviewRequestCardContainer } from 'components/DocRightRail/screens/AIAssistant/ReviewRequestCard/ReviewRequestCardContainer'
import { useInformalFeedbackRequests } from 'hooks/almanacFiles/useInformalFeedbackRequests'
import { useInformalFeedbackRequestRealtimeChannel } from 'hooks/almanacFiles/useInformalFeedbackRequestRealtimeChannel'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'

interface Props {
  fileId: string
  channel?: ChannelType | DesignChannel
}

export const ReviewRequestCardWrapper = ({ fileId, channel }: Props) => {
  const { openRequest, mostRecentClosedRequest } = useInformalFeedbackRequests(fileId)
  const request = openRequest || mostRecentClosedRequest

  useInformalFeedbackRequestRealtimeChannel(fileId)

  return <ReviewRequestCardContainer request={request} assetType="article" channel={channel} />
}
